import React from 'react'
import { ProtectedRoute } from 'components/ProtectedRoute'
import { CIMSPage, Permission } from 'shared'
import { Switch } from 'react-router-dom'
import NonUserEmails from './components/NonUserEmails'
import Roles from './components/Roles'
import Users from './components/Users'
import ProjectSettings from './components/ProjectSettings'
import CustomFields from './components/CustomFields'
import { ProjectSettingsProvider } from './components/ProjectSettings/ProjectSettingsContext'

const Administration: React.FC = () => {
  return (
    <Switch>
      <ProtectedRoute
        path={CIMSPage.CustomFields.projectPath}
        permissions={Permission.ViewCustomField}
      >
        <CustomFields />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.Users.projectPath}
        permissions={Permission.ViewUser}
      >
        <Users />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.Roles.projectPath}
        permissions={Permission.ViewRole}
      >
        <Roles />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.NonUserEmails.projectPath}
        permissions={Permission.ViewNonUserEmail}
      >
        <NonUserEmails />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.ProjectSettings.projectPath}
        permissions={Permission.ViewProjectSettings}
      >
        <ProjectSettingsProvider>
          <ProjectSettings />
        </ProjectSettingsProvider>
      </ProtectedRoute>
    </Switch>
  )
}

export default Administration
